

























































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";
import SelectStadium from "@/components/selectstadium.vue";
import Edit from "./edit.vue";
import Members from "./members.vue";
import Bulletins from "./activity_bulletins.vue";
import Activities from "./activity.vue";

@Component({
  components: {
    Edit,
    SelectStadium,
    Members,
    Bulletins,
    Activities,
  },
})
export default class extends Mixins(MyList) {
  membersModalVisible = false;

  bulletinsModalVisible = false;

  activityModalVisible = false;

  dispatchType = "club/list";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "俱乐部名称", dataIndex: "club_name" },
    { title: "俱乐部类型", scopedSlots: { customRender: "club_type" } },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "成员数", scopedSlots: { customRender: "usercount" } },
    { title: "大型活动数", scopedSlots: { customRender: "bulletincount" } },
    { title: "活动数", scopedSlots: { customRender: "activitycount" } },
    { title: "创建时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadData();
  }

  showMembersModal(id: number) {
    this.editId = id;
    this.membersModalVisible = true;
  }

  hideMembersModal() {
    this.membersModalVisible = false;
  }

  showBulletinsModal(id: number) {
    this.editId = id;
    this.bulletinsModalVisible = true;
  }

  hideBulletinsModal() {
    this.bulletinsModalVisible = false;
  }

  showActivityModal(id: number) {
    this.editId = id;
    this.activityModalVisible = true;
  }

  hideActivityModal() {
    this.activityModalVisible = false;
  }
}
